import React from 'react';
import './GuidelinesAgreementScreen.css';

const GuidelinesAgreementScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="guidelines-agreement-screen">
      <h1>Guidelines & Agreement</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default GuidelinesAgreementScreen; 